import Call from "./call";
export default Call;


// WEBPACK FOOTER //
// /src/call/call/index.js